import React from 'react';
import swal from "sweetalert";
import FusionCharts from 'fusioncharts/core';
import Pyramid from 'fusioncharts/viz/pyramid';

FusionCharts.addDep(Pyramid);

class TipoClientes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            days: {},
            config: {},
            ctx: {}
        };
    }

    componentWillMount() {
        let self = this;
    }

    componentDidMount() {
        let self = this;
        let month_url = "";

        switch (month) {
            case "enero":
                month_url = "01";
                break;
            case "febrero":
                month_url = "02";
                break;
            case "marzo":
                month_url = "03";
                break;
            case "abril":
                month_url = "04";
                break;
            case "mayo":
                month_url = "05";
                break;
            case "junio":
                month_url = "06";
                break;
            case "julio":
                month_url = "07";
                break;
            case "agosto":
                month_url = "08";
                break;
            case "septiembre":
                month_url = "09";
                break;
            case "octubre":
                month_url = "10";
                break;
            case "noviembre":
                month_url = "11";
                break;
            case "diciembre":
                month_url = "12";
                break;
        }

        if (year >= 2023) {
            axios.get('/api/reports/' + month_url + '/' + year + '/tipo_clientes')
            .then(response => {
                let tarjeta = response.data.tarjeta;
                let folio = response.data.folio;

                FusionCharts.ready(function () {
                    let revenueChart = new FusionCharts({
                        type: 'pyramid',
                        renderAt: 'tipo_clientes-chart',
                        width: '100%',
                        height: '80%',
                        dataFormat: 'json',
                        dataSource: {
                            "chart": {
                                "xAxisname": "Clientes",
                                "yAxisName": "Cantidad",
                                "showValues": "1",
                                "bgColor": "#ffffff",
                                "showLegend": "0",
                                "legendPosition": "right",
                                "showTooltip": "1",
                                "borderThickness": "0",
                                "is2d": "0",
                                "palettecolors": "836890, 6DB3BF"
                            },
                            "data": [
                                {
                                    "label": "Folio DESCLUB",
                                    "value": folio
                                },
                                {
                                    "label": "Tarjeta Sí Vale",
                                    "value": tarjeta
                                }
                            ]
                        }
                    }).render();

                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "No se han obtenido resultados.",
                    icon: "warning",
                });
            });
        }
    }

    render() {
        return (
            <div id='tipo_clientes-chart'></div>
        );
    }
}

export default TipoClientes;


// WEBPACK FOOTER //
// ./resources/assets/react/dashboard/TipoClientes.jsx